import {createAction} from 'redux-actions';
import {getQcToolsTerritorialRatingDescriptors} from '@pluto/rest';
import {DescriptorsPayload} from 'QCTools/QCToolsMetadata/QCToolsMetadataTypes';

export const SET_QC_DESCRIPTORS = 'SET_QC_DESCRIPTORS';

export const setQcDescriptors = createAction<Promise<DescriptorsPayload>>(SET_QC_DESCRIPTORS, async () => {
    return await getQcToolsTerritorialRatingDescriptors();
});
